import { css, SerializedStyles } from '@emotion/core'

export const getTruncateStyle = (): SerializedStyles => css`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`
